import { type JSX, cloneElement } from 'react';
// oxlint-disable-next-line no-restricted-imports
import type { PopoverPlacement } from '@launchpad-ui/core';
// oxlint-disable-next-line no-restricted-imports
import { Tooltip } from '@launchpad-ui/core';
import cx from 'clsx';

import { RestrictProvider } from '../AccessCheck/RestrictProvider';

const defaultTooltip = 'You are not allowed to perform this action. Contact your administrator for more information.';

export type RestrictProps = {
  name?: string;
  tooltip?: string | JSX.Element;
  tooltipOptions?: {
    placement?: PopoverPlacement;
    rootElementStyle?: object;
    targetClassName?: string;
  };
  isRestricted: boolean;
  willHide?: boolean;
  willDisable?: boolean;
  disableTooltip?: boolean;
  children: JSX.Element | ((disabled?: boolean) => JSX.Element);
};

export const Restrict = ({
  isRestricted,
  willHide,
  willDisable,
  tooltip,
  tooltipOptions = {},
  disableTooltip,
  children,
}: RestrictProps) => {
  if (isRestricted) {
    const element =
      typeof children === 'function'
        ? children(willDisable)
        : cloneElement(children, { disabled: willDisable, isDisabled: willDisable });
    const finalTooltip = disableTooltip ? '' : tooltip || defaultTooltip;

    if (willHide) {
      return null;
    }

    const finalTooltipOptions = {
      ...tooltipOptions,
      targetClassName: cx('Popover-target', tooltipOptions.targetClassName),
    };

    return (
      <RestrictProvider isDisabled={!!willDisable}>
        <Tooltip targetTestId="restrict-tooltip" {...finalTooltipOptions} content={finalTooltip}>
          {element}
        </Tooltip>
      </RestrictProvider>
    );
  }

  return typeof children === 'function' ? children(undefined) : children;
};
